import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDiamond: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="diamond, pro, premium"><path d="M7.39286 3.75L1.25 10L12 20.75L22.75 10L16.6071 3.75H7.39286Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.5 7.75L6.25 10L8.5 12.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconDiamond;
